import { HttpClient } from '@angular/common/http';
import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';

import { UserAuthorizationService } from '../../services/user-authorization.service';

@Component({
    templateUrl: './login.component.html'
})
export class LoginComponent implements OnInit {

    error?: string;

    constructor(private userAuthorizationService: UserAuthorizationService, private router: Router, private httpClient: HttpClient) {
    }

    async ngOnInit() {
        await this.userAuthorizationService.loadUserAsync();
        this.router.navigateByUrl('/');
    }

}
